interface promoMonthsLeftAfterFirstPayment {
  firstPaymentCycles?: number;
  promoMonthsLeftAfterFirstPayment?: number;
}

export function shouldDisplayTimelineInMembershipCheckoutBox(
  config?: promoMonthsLeftAfterFirstPayment
) {
  const { firstPaymentCycles = 0, promoMonthsLeftAfterFirstPayment = 0 } =
    config || {};
  return firstPaymentCycles > 0 || promoMonthsLeftAfterFirstPayment > 0;
}
